import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT } from '@app/model/process-request/service/ProcessRequestGraphQLFragments';


export const GET_METARADAR_STATE_QUERY: GraphQL = {
	name: 'getMetaradarStateSnapshot',
	gql: gql`
      query getMetaradarStateSnapshot($companyHotelId: Long!) {
          getMetaradarStateSnapshot(companyHotelId: $companyHotelId) {
              companyHotelId
              lastUpdateDate
              dailyItems {
                  stateId
                  statDate
                  isAvailable
                  items {
                      provider
                      id
                      creationDate
                      provider
                      region
                      isBrandOffer
                      isSoldOut
                      price {
                          amount
                          currency
                      }
                      url
                      iconUrl
                  }
              }
          }
      }
	`,
};

const METARADAR_REFRESH_STATUS_FIELDS = gql`
    ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
    fragment MetaradarRefreshStatusFields on MetaradarRefreshStatus {
        status
        retryAfterSeconds
        executionState {
            ...ProcessRequestExecutionStateFields
        }
    }
`;

export const GET_METARADAR_REFRESH_STATUS_QUERY: GraphQL = {
	name: 'getMetaradarRefreshStatus',
	gql: gql`
      ${METARADAR_REFRESH_STATUS_FIELDS}
      query getMetaradarRefreshStatus($companyHotelId: Long!) {
          getMetaradarRefreshStatus(companyHotelId: $companyHotelId) {
              ...MetaradarRefreshStatusFields
          }
      }
	`,
};

export const TRIGGER_METARADAR_REFRESH_MUTATION: GraphQL = {
	name: 'triggerMetaradarRefresh',
	gql: gql`
      ${METARADAR_REFRESH_STATUS_FIELDS}
      mutation triggerMetaradarRefresh($companyHotelId: Long!) {
          triggerMetaradarRefresh(companyHotelId: $companyHotelId) {
              ...MetaradarRefreshStatusFields
          }
      }
	`,
};
